import { AppBar as MuiAppBar, Toolbar, alpha, styled } from '@mui/material';

import { drawerWidth } from '../PageBase/PageBase';

export const CustomAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  paddingTop: theme.spacing(11),
  backgroundColor: theme.palette.background.main,
  marginLeft: theme.spacing(14),
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: `calc(50px + ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const CustomToolbar = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ theme, open }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: 'transparent',
  marginLeft: theme.spacing(16),
  transition: theme.transitions.create(['margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: `calc(50px + ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const SearchBar = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: 23,
  backgroundColor: theme.palette.background.secondary,
  color: theme.palette.text.tertiary,
  '&:hover': {
    backgroundColor: alpha(theme.palette.background.secondary, 0.85),
  },
  marginRight: theme.spacing(6),
  marginLeft: 0,
  width: '500px!important',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(8),
    width: 'auto',
  },
}));

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 6),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
